import {FormikErrors} from 'formik';
import set from 'lodash/set';
import get from 'lodash/get';
import moment from 'moment';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {
  validateAmount,
  validateTextField,
} from '../CreateBuilder/BuilderSourceDestination/builderValidators';
import FREQUENCY, {FREQUENCY_COMBOS} from '../../../constants/Frequency';
import {SaltusAny} from '../../../utils/SaltusAny';

export const validateWithdrawalFrequency = (
  values: builderFieldsType,
  errors: FormikErrors<builderFieldsType>
) => {
  const frequency = values.withdraw?.source?.frequency;
  const start = values.withdraw?.source?.start;

  if (!frequency) {
    set(errors, 'withdraw.source.frequency', 'Frequency is required');
    return;
  }

  if (frequency !== FREQUENCY.SINGLE) {
    if (!start) {
      set(errors, 'withdraw.source.start', 'Start date is required');
      return;
    }
    const minDate = moment.utc().add(10, 'days');
    if (minDate.isAfter(start)) {
      set(errors, 'withdraw.source.start', 'Date must be at least 10 days in the future');
    }
  }
};

export const withdrawalValidator = (
  values: builderFieldsType,
  errors: SaltusAny
): FormikErrors<builderFieldsType> => {
  const withdrawFrequency = values.withdraw?.source?.frequency;
  const hasSingle = withdrawFrequency === FREQUENCY.SINGLE;
  const hasRecurring = !!withdrawFrequency && withdrawFrequency !== FREQUENCY.SINGLE;
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const withdrawValues = values.withdraw;
  if (!withdrawValues?.source) {
    errors.withdraw = 'Select withdrawal source';
    return errors;
  }
  if (!withdrawValues.source?.id) {
    set(errors, 'withdraw.source', 'Required');
  }
  const withdrawReason = get(values, 'withdraw.source.reason');
  validateTextField(withdrawReason, 'withdraw.source.reason', errors);

  if (hasSingle && withdrawReason !== 'Max Tax Free Cash') {
    validateAmount({
      sourceValues: withdrawValues.source,
      errors,
      amountType: 'singleClientAmount',
      key: 'withdraw.source.singleClientAmount',
    });
  }
  if (hasRecurring) {
    validateAmount({
      sourceValues: withdrawValues.source,
      amountType: 'recurringClientAmount',
      errors,
      key: 'withdraw.source.recurringClientAmount',
    });
  }
  validateWithdrawalFrequency(values, errors);
  // Destination must be one of the client's existing bank accounts (DBO-1436)
  if (!withdrawValues.destination?.id) {
    set(errors, 'withdraw.destination', 'Select a destination bank account');
  }
  return errors;
};
